import React from 'react';
import styles from './SectionHeader.module.css';

/**
 * A simple, reusable header for sections within a page or tab.
 *
 * @param {object} props
 * @param {string} props.title - The title text for the section.
 * @param {React.ReactNode} [props.children] - Elements to render in the right-hand action slot.
 */
const SectionHeader = ({ title, children }) => {
  return (
    <header className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
      {children && (
        <div className={styles.actions}>
          {children}
        </div>
      )}
    </header>
  );
};

export default SectionHeader;